import { router } from 'expo-router';
import { RuntimeAsyncState } from '@/features/unified-learning/runtime/components/RuntimeAsyncState';
import { ADVANCED_TOOL_META, type AdvancedToolKey } from '@/constants/learnLaunchConfig';

type Props = {
  tool: AdvancedToolKey;
};

export function AdvancedToolGateScreen({ tool }: Props) {
  const meta = ADVANCED_TOOL_META[tool];
  return (
    <RuntimeAsyncState
      state="degraded"
      title={`${meta.title} ייפתח בהמשך הבטא`}
      description={`בגרסת הבטא אנו מתמקדים בלולאת הליבה: שיעור → תרגול → סקירה → מבחן. ${meta.whenToUse}`}
      actionLabel="חזרה לבית המסלול"
      onAction={() => router.back()}
    />
  );
}
